import React, { Component, Fragment } from 'react';
import Wrapper from './../../../../../common/component/Wrapper';
import {
    getTitleTable, formatMoney, columnsTable,
    getDataSource, genaratePaginateFilterSort,
    getPermissionActions
} from '../../../../../../../helpers/functions';
import { parseListRequestParams, getLocaleFullName, getColumnVisibleConfigs } from '../../../../../../../utils/commonUtils';
import { generateStringId } from '../../../../../../../utils/orders';
import * as HMS from "../../../../../common/component/Index";
import * as Func from '../../../../../../../helpers/functions';
import SaleReportBySKU, { SaleReportBySkuItem } from '../../../../../../../models/SaleReportBySKU';
import DEFINE, { CHANNELS, DATE_TIME_FORMAT, ORDER, PATHS, SALE_CHANNELS, VOUCHER } from '../../../../../../../constants/Define';
import { FormWrapperItem, ListComponent, DatePickerComponent } from '../../../../../common/component/Index';
import Button, { ButtonGroup } from '../../../../../common/component/Button';
import * as ANT from 'antd';
import { omit, find, toArray } from 'lodash';
import i18n from "../../../../../../../constants/initLng";
import FontIcon, { SolidIcons } from '../../../../../common/component/FontIcon';
import Span from '../../../../../common/component/Span';
import moment from 'moment';
import EllipsisText from '../../../../../common/component/EllipsisText';
import { Link } from 'react-router-dom';

let permisionActions = [];
const defaultState = {
    filterExport: {}
};

const removeColumns = ['id', 'memberShipName'];
const ReportListCols = [
'id', 'orderCode', 'orderId', 'paymentType', 'paymentStatus', 'orderStatus', 'memberShipCode', 'saleChannel', 'affiliateSource', 'channel', 'orderItemType', 
'createdDate', 'fullname', 'email', 'phoneNumber', 'fullnameCustomer', 'emailCustomer', 'phoneNumberCustomer', 'memberShipName', 
'couponCode', 'couponValue', 'subTotal', 'surcharge', 'surchargeDetail', 'totalChangeRateCode', 'totalAmount', 'note', 
'skuCode', 'skuName', 'urlSlug', 'endDate', 'bookingPeriod', 'groupName', 'rateCode', 'rateName',
'ticketCode', 'ticketName', 'ticketPrice', 'totalRounding',
'supplierCode', 'supplierName', 'supplierType', 'supplierProductCode', 'supplierProductName', 'supplierProductPrice', 
'serialNumber', 'checkCode', 'voucherStatus', 'operaBookingCode', 'checkInDate', 'checkOutDate', 'departureLocation', 'property',
'agentId', 'installmentFee', 'installmentLimit', 'outletName', 'sessionInfo'];
const CURRENT_DATE_RANGE_ENUM = {
    DATE: [moment.utc().startOf('days'), moment.utc().endOf('days')],
    WEEK: [moment.utc().startOf('isoWeeks'), moment.utc().endOf('days')],
    MONTH: [moment.utc().startOf('months'), moment.utc().endOf('days')],
}
let orderOnline = ['onepay', 'vnpay', 'onepay_installment']
export default class ReportList extends Component {
    getSearchOption = () => {
        return {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <HMS.FilterDropdown
                    setSelectedKeys={setSelectedKeys}
                    selectedKeys={selectedKeys}
                    confirm={confirm}
                    clearFilters={clearFilters}
                >
                </HMS.FilterDropdown>
            ),
            filterIcon: filtered => (
                <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: getTitleTable(ReportListCols, [], removeColumns),
            modelItem: ReportListCols,
            applyDateRanges: null,
            componentTable: {
                orderCode: {
                    key: 'orderCode',
                    ...this.getSearchOption(),
                    render: (text, record) => 
                            <Link to={Func.getPathWithParams(PATHS.ORDER.DETAIL.path, { id: record.orderId })} className={`mr-2 colorPrimary`}>
                                <Span>{text}</Span>
                            </Link>
                },
                orderId: {
                    visible: false,
                    key: 'orderId',
                    ...this.getSearchOption(),
                },
                paymentType: {
                    key: 'paymentType',
                    render: (paymentType, data) => <Fragment>
                        {paymentType && <div className="g-mt-5">
                            <HMS.StatusComponent color={'gray'}
                                label={i18n.t(`item.order.paymentTypes.${data.paymentType}`)} />
                        </div>
                        }
                    </Fragment>,
                    sorter: (i, k) => i.paymentType - k.paymentType,
                },
                paymentStatus: {
                    key: 'paymentStatus',
                    render: (paymentStatus, data) => <Fragment>
                        <HMS.StatusComponent color={paymentStatus === 2 ? 'green' : (paymentStatus === 4 ? 'blue' : 'red')}
                            label={i18n.t(`item.order.paymentStatusEnum.${paymentStatus}`)} />
                        <br />
                    </Fragment>,
                    filters: [
                        { value: 1, text: this.props.t(`item.order.paymentStatusEnum.1`) },
                        { value: 2, text: this.props.t(`item.order.paymentStatusEnum.2`) },
                        { value: 4, text: this.props.t(`item.order.paymentStatusEnum.4`) },
                        { value: 5, text: this.props.t(`item.order.paymentStatusEnum.5`) },
                    ],
                    filterMultiple: false,
                },
                orderStatus: {
                    key: 'OrderStatus',
                    render: (status, data) => <Fragment>
                        <HMS.StatusComponent color={data.orderStatus === 2 ? 'green' : (data.orderStatus === 4 ? 'blue' : 'red')}
                            label={i18n.t(`item.order.orderStatus.${data.orderStatus}`)} />
                    </Fragment>,
                    filters: Object.keys(ORDER.ENUM_STATUS).map(key => ({
                        value: ORDER.ENUM_STATUS[key].value,
                        text: this.props.t(`item.order.orderStatus.${ORDER.ENUM_STATUS[key].value}`)
                    })),
                    filterMultiple: false,
                    sorter: (i, k) => i.orderStatus - k.orderStatus,
                },
                memberShipCode: {
                    visible: false,
                    sorter: (i, k) => i.memberShipCode - k.memberShipCode,
                },
                saleChannel: {
                    key: 'saleChannel',
                    render: (value, data) => value && i18n.t(`item.order.saleChannels.${value}`),
                    sorter: (i, k) => i.saleChannel - k.saleChannel,
                },
                affiliateSource: {},
                channel: {
                    key: 'channels',
                    render: (value, data) => value && i18n.t(`item.order.channels.${value}`),
                    // sorter: (i, k) => i.channels - k.channels,
                    filters: Object.keys(CHANNELS).map(item => (
                        { value: CHANNELS[item], text: this.props.t(`item.order.channels.${CHANNELS[item]}`) 
                    })),
                    filterMultiple: true,
                },
                orderItemType: {
                    key: 'itemTypes',
                    width: 100,
                    render: (type) => {
                        const typeKey = find(Object.keys(ORDER.TYPES), k => ORDER.TYPES[k].id === type)
                        return typeKey && <ANT.Tooltip key={typeKey} title={this.props.t(`item.order.orderTypes.${ORDER.TYPES[typeKey].key}`)}><Span className="ml-2">
                            <FontIcon key={type} color={ORDER.TYPES[typeKey].color} icon={SolidIcons[ORDER.TYPES[typeKey].icon]} size="lg" />
                        </Span></ANT.Tooltip>
                    },
                    sorter: (i, k) => i.orderItemType - k.orderItemType,
                },
                createdDate: {
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.DATE_TIME)
                },
                fullname: {
                    key: 'fullname',
                    render: (text, data) => data.fullname || getLocaleFullName(data.firstname, data.lastname),
                    ...this.getSearchOption(),
                },
                email: {
                    visible: false,
                    key: 'email',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />,
                    ...this.getSearchOption(),
                },
                phoneNumber: {
                    visible: false,
                    key: 'phoneNumber',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />,
                    ...this.getSearchOption(),
                },
                fullnameCustomer: {
                    visible: false,
                    key: 'fullnameCustomer',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />,
                    ...this.getSearchOption(),
                },
                emailCustomer: {
                    visible: false,
                    key: 'emailCustomer',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />,
                    ...this.getSearchOption(),
                },
                phoneNumberCustomer: {
                    visible: false,
                    key: 'phoneNumberCustomer',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />,
                    ...this.getSearchOption(),
                },
                memberShipName: {},
                couponCode: {
                    key: 'couponCode',
                    ...this.getSearchOption(),
                    render: (text, record) => text
                },
                couponValue: {
                    align: "right",
                    render: (value) => Func.formatMoney(value)
                },
                subTotal: {
                    align: "right",
                    render: (value) => Func.formatMoney(value)
                },
                surcharge: {
                    align: "right",
                    render: (value) => Func.formatMoney(value)
                },
                surchargeDetail: {},
                totalChangeRateCode: {
                    align: 'right',
                    width: 200,
                    render: (amount) => Func.formatMoney(amount)
                },
                totalAmount: {
                    align: "right",
                    render: (amount) => Func.formatMoney(amount)
                },
                note: {
                    visible: false,
                    key: 'note',
                    width: 300,
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />,
                    ...this.getSearchOption(),
                },
                skuCode: {
                    key: 'skuCode',
                    ...this.getSearchOption(),
                    render: (text, record) => text
                },
                skuName: {
                    key: 'skuName',
                    render: (text, record) => <EllipsisText title={text} content={<a href={record.urlSlug} target="_blank" rel="noopener noreferrer">{text}</a>} contentMaxWidth={300}
                    overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />,
                    ...this.getSearchOption(),
                },
                urlSlug: {
                    visible: false,
                    render: (text, record) => text
                },
                endDate: {
                    visible: false,
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                bookingPeriod: {
                    visible: false,
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                groupName: {
                    key: 'groupName',
                    ...this.getSearchOption()
                },
                rateCode: {
                    key: 'rateCode',
                    ...this.getSearchOption()
                },
                rateName: {
                    key: 'rateName',
                    ...this.getSearchOption()
                },
                ticketCode: {
                    key: 'ticketCode',
                    ...this.getSearchOption()
                },
                ticketName: {
                    key: 'ticketName',
                    ...this.getSearchOption()
                },
                ticketPrice: {
                    render: (price) => Func.formatMoney(price)
                },
                totalRounding: {
                    render: (price) => Func.formatMoney(price)
                },
                supplierCode: {
                    visible: false,
                    key: 'supplierCode',
                    ...this.getSearchOption()
                },
                supplierName: {
                    visible: false,
                    key: 'supplierName',
                    ...this.getSearchOption()
                },
                outletName: {
                    key: 'OutletName',
                    width: 300,
                    ...this.getSearchOption(),
                    render: (text, record) => {
                        if (!record.sessionInfo || !record?.sessionInfo?.sessionId) return null;
                        return <Wrapper className="d-flex flex-row align-items-center">
                                        <Span className="mr-1">{`${record?.sessionInfo?.nameOutlet}`}</Span>
                                    </Wrapper>
                    }
                },
                sessionInfo: {
                    key: 'sessionInfo',
                    render: (text, record) => {
                        if (!record.sessionInfo || !record?.sessionInfo?.sessionId) return null;
                        return <Wrapper className="d-flex flex-row align-items-center">
                                        <Span className="mr-1">{`${record?.sessionInfo?.startHour}: ${record?.sessionInfo?.startMinute === 0 ? '00' : record?.sessionInfo?.startMinute}`} - {`${record?.sessionInfo?.endHour}: ${record?.sessionInfo?.endMinute === 0 ? '00' : record?.sessionInfo?.endMinute}`}</Span>
                                    </Wrapper>
                    }
                },
                supplierType: {
                    visible: false,
                    key: 'supplierType',
                    sorter: (i, k) => i.supplierType - k.supplierType,
                },
                supplierProductCode: {
                    visible: false,
                    key: 'supplierProductCode',
                    ...this.getSearchOption()
                },
                supplierProductName: {
                    visible: false,
                },
                supplierProductPrice: {
                    visible: false,
                    render: (price) => Func.formatMoney(price)
                },
                serialNumber: {},
                checkCode: {},
                voucherStatus: {
                    key: 'voucherStatus',
                    render: (status, record) => {
                        const statusEnum = find(toArray(VOUCHER.STATUS), item => item.id === status)
                        return !!statusEnum && <Fragment>
                            <HMS.StatusComponent color={!record.isExpired ? statusEnum.color : 'grey'}
                                label={this.props.t(`item.voucher.statusVoucher.${statusEnum.key}`)} />
                            {record.isLocked && <ANT.Icon type="lock" style={{ color: VOUCHER.STATUS.LOCKED.color }} />}
                        </Fragment>
                    },
                    sorter: (i, k) => i.voucherStatus - k.voucherStatus,
                },
                operaBookingCode: {
                    visible: false,
                },
                checkInDate: {
                    render: (text, record) => text && record.orderItemType !== 1 && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                checkOutDate: {
                    render: (text, record) => text && record.orderItemType !== 1 && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                departureLocation: {
                    visible: false,
                },
                property: {
                    key: 'property',
                    ...this.getSearchOption()
                },
                agentId: {
                    visible: false,
                    key: 'agentId',
                    ...this.getSearchOption()
                },
                installmentFee: {
                    visible: false,
                },
                installmentLimit: {
                    visible: false,
                }
            },
        };
    }

    componentDidMount() {
        permisionActions = getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.ORDER_DETAIL_REPORT_BY_SKU);
    }

    render() {
        const { t, report, downloading } = this.props;

        return (
            <Wrapper className="col-md-12 p-0 mt-3 report-list order-detail-sku">
                <Wrapper className="col-md-12 row m-0 p-0 report-list-title align-items-end">
                    <h3 className={`col-md-2 ml-0 p-0`}>{""}</h3>
                    <Wrapper className={`col-md-6 m-0 p-0 pr-2 button-section`}>
                        {permisionActions && permisionActions.allowExportFileExcel &&
                            <Button type="primary" onClick={() => this.onExportExcel(false)}
                                icon="download" loading={downloading}
                                disabled={!(report.items && report.items.length)}
                                className="mr-2">{t(`item.report.exportExcel`)}</Button>
                        }
                    </Wrapper>
                    <Wrapper className={`align-items-end col-md-4 d-flex flex-column m-0 p-0`}>
                        <ButtonGroup>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.DATE })}>{t(`item.report.currentDate`)}</Button>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.WEEK })}>{t(`item.report.currentWeek`)}</Button>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.MONTH })}>{t(`item.report.currentMonth`)}</Button>
                        </ButtonGroup>
                        <DatePickerComponent className={`form-control applyDates w100-percent mt-1`}
                            hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.SHORT_DATE}
                            style={{ padding: 0, border: 0 }}
                            onChange={this.onSelectDateRange} name={`applyDates`}
                            placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                            value={[report.startDate, report.endDate]}
                            onCalendarChange={val => this.setState({...this.state, applyDateRanges: val })}
                            disabledDate={this.disabledDate}
                            onOpenChange={this.onOpenChange}
                        />
                    </Wrapper>
                </Wrapper>
                {this.renderList()}
            </Wrapper>
        );
    }

    renderList() {
        const { report, loading } = this.props;
        const { items } = report
        const filters = omit(report, 'items')
        const { titleItemTable, modelItem, componentTable } = this.state


        return (
            <Wrapper className={`mt-2`}>
                <ListComponent
                    tableKey="order-detail-report-sku"
                    scroll={{ x: 5500 }}
                    classParent="m-0 p-0 sale-report-list"
                    marginTop={'0'} marginBottom={'0'}
                    loading={{ spinning: loading, size: 'large' }}
                    rowKey={(record, k) => generateStringId(10)}
                    dataSource={getDataSource(items || [], modelItem)}
                    columns={columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'orderDetailReportSku'
                    })}
                    pagination={{ total: filters.totalCount, totalPage: filters.totalPage, current: filters.pageIndex, pageSize: filters.pageSize }}
                    onChange={this.onTableChange}
                    componentTableList={{}}
                />
            </Wrapper>
        )
    }

    onSelectDateRange = (data) => {
        const dateRange = data.fullValue || data.value || [];
        if (!dateRange[0] || !dateRange[1]) return;
        const filters = this.getCurrentFilters()
        filters.pageIndex = 1;
        filters.startDate = moment.utc(dateRange[0], DATE_TIME_FORMAT.SHORT_DATE);
        filters.endDate = moment.utc(dateRange[1], DATE_TIME_FORMAT.SHORT_DATE).endOf("day");
        if (filters.endDate.diff(filters.startDate, 'days') >= 31) {
            filters.endDate = moment(filters.startDate).add(30, 'days')
        }
        return this.props.onChangeFilters({ ...this.state.filterExport, ...filters });
    }

    disabledDate = (current) => {
        const dates = this.state.applyDateRanges;
        if (!dates) {
          return false;
        }
        const tooLate = dates[0] && current.diff(dates[0], 'days') >= 31;
        const tooEarly = dates[0] && dates[0].diff(current, 'days') >= 31;
        return !!tooEarly || !!tooLate;
    };

    onOpenChange = (open) => {
        if (open) {
          this.setState([null, null]);
          this.setState({...this.state, applyDateRanges: [null, null]});
        }
    };

    onTableChange = (pagination, filters, sorter) => {
        const currentFilters = this.getCurrentFilters();
        filters = omit({ ...currentFilters, ...filters }, ['pageSize', 'pageIndex']);
        let newFilters = genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({ filterExport: newFilters })
        this.props.onChangeFilters(newFilters);
    };

    onChangeFilters = (fieldName, value) => {
        const filters = this.getCurrentFilters()
        filters[fieldName] = value;
        return this.props.onChangeFilters({ ...this.state.filterExport, ...filters })
    }

    onExportExcel = (isExcludeUserInfo = false) => {
        const { componentTable } = this.state;
        const defineColumns = Object.keys(componentTable).map(field => ({dataIndex: field, visible: componentTable[field]?.visible }));
        const visibledColumns = getColumnVisibleConfigs("order-detail-report-sku", defineColumns);
        const filters = this.getCurrentFilters();
        filters.pageIndex = undefined;
        filters.pageSize = undefined;
        filters.isExcludeUserInfo = isExcludeUserInfo;
        filters.headerReport = visibledColumns.filter(x=> x.visible !== false).map(x=> x.dataIndex).join(",");
        return this.props.onExportExcel(parseListRequestParams({ ...this.state.filterExport, ...filters }));
    }

    getCurrentFilters() {
        const { report } = this.props;
        return omit(report, ['items', 'totalCount', 'totalPage']);
    }
}

ReportList.defaultProps = {
    report: new SaleReportBySKU(),
    loading: false,
    downloading: false,
    onChangeFilters: filters => { },
    onExportExcel: filters => { },
}
